import { useGame } from "../../context/GameContext.jsx";

export function LangToggle() {
  const { state, dispatch } = useGame();
  return (
    <button
      onClick={() => dispatch({ type: "SET_LANGUAGE", payload: state.language === "fr" ? "en" : "fr" })}
      className="bg-amber-950/60 border border-amber-800/40 rounded-full
        px-3 py-1.5 text-amber-400 text-xs font-semibold active:scale-95 transition-all shrink-0">
      {state.language === "fr" ? "🇬🇧 EN" : "🇫🇷 FR"}
    </button>
  );
}
